<div [ngStyle]="{'background-color': color, 'min-width':messageLength+'px'}" class="toastr-class">
   <span *ngIf="isIconShown" class="icon-success"><img [src]=iconSource alt=""/></span> 
   <span id="toast" class="message">{{(message | customTranslation : translationData) ? (message | customTranslation : translationData): message}} </span>
</div>
